<template>
  <div class="payment-success">
    <div class="content">
      <div class="result">
        <van-icon name="checked" class="result-icon" />
        <div class="result-title">报名费支付成功</div>
        <div class="result-sub">{{ match.unionMatchName || match.chineseName || '-' }}</div>
      </div>

      <div class="card">
        <div class="card-main">
          <div class="logo">
            <img v-if="player.avatar" :src="imageView(player.avatar)" alt="" />
            <img v-else src="@/assets/player-default.png" alt="" />
          </div>
          <div class="info">
            <div class="name">{{ player.trueName || '-' }}</div>
            <div class="minor">{{ team.name || team.teamName || '-' }}</div>
          </div>
        </div>
      </div>

      <div class="next">
        <div class="next-left">
          <div class="next-title">去赛事主页</div>
          <div class="next-sub">了解最新比赛赛程·积分·公告</div>
        </div>
        <van-button round type="info" class="next-btn" @click="goMatchHome">前往</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Icon, Button, Toast } from 'vant'
import { getBMMatchTeamSignup } from '@/api/match'
import { QNImageUtil } from '@/utils'

Vue.use(NavBar).use(Icon).use(Button).use(Toast)

export default {
  name: 'PaymentSuccess',
  data() {
    return {
      matchId: '',
      teamId: '',
      playerId: '',
      orderId: '',
      match: {},
      team: {},
      player: {}
    }
  },
  mounted() {
    this.matchId = this.$route.query.matchId || ''
    this.teamId = this.$route.query.teamId || ''
    this.playerId = this.$route.query.playerId || ''
    this.orderId = this.$route.query.orderId || ''
    this.fetchInfo()
  },
  methods: {
    imageView(img) {
      return img ? QNImageUtil.imageView(img) : ''
    },
    async fetchInfo() {
      if (!this.matchId || !this.teamId) return
      try {
        const res = await getBMMatchTeamSignup({ matchId: this.matchId, teamId: this.teamId })
        const data = (res && res.data) || {}
        this.match = data.match || {}
        this.team = data.team || {}
        const players = data.players || []
        this.player = players.find(p => String(p.id) === String(this.playerId)) || {}
      } catch (e) {
        Toast.fail(e?.message || '获取信息失败')
      }
    },
    goMatchHome() {
      const unionMatchId = this.match.unionMatchId || this.$route.query.unionMatchId || ''
      if (unionMatchId) {
        this.$router.replace({
          name: 'MatchOverall',
          query: { unionMatchId }
        })
        return
      }
      this.$router.replace({ name: 'ApplyHome' })
    }
  }
}
</script>

<style scoped lang="scss">
.payment-success {
  min-height: 100vh;
  background: #f6f6f8;
  .content {
    padding: 16px;
  }
}
.result {
  background: #fff;
  border-radius: 10px;
  padding: 22px 16px 18px;
  text-align: center;
  .result-icon {
    font-size: 42px;
    color: #1989fa;
    margin-bottom: 10px;
  }
  .result-title {
    font-size: 18px;
    font-weight: 600;
    color: #1d2129;
    line-height: 26px;
  }
  .result-sub {
    font-size: 13px;
    color: #86909c;
    margin-top: 6px;
  }
}
.card {
  margin-top: 12px;
  background: #fff;
  border-radius: 10px;
  padding: 14px 16px;
  .card-main {
    display: flex;
    align-items: center;
  }
  .logo {
    width: 52px;
    height: 52px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
    background: #e8e8e8;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .info {
    flex: 1;
    margin-left: 12px;
    min-width: 0;
    .name {
      font-size: 16px;
      font-weight: 600;
      color: #1d2129;
      line-height: 22px;
    }
    .minor {
      margin-top: 6px;
      font-size: 13px;
      color: #606266;
    }
  }
}
.next {
  margin-top: 12px;
  background: #fff;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  .next-left {
    flex: 1;
    min-width: 0;
  }
  .next-title {
    font-size: 15px;
    font-weight: 600;
    color: #1d2129;
    line-height: 22px;
  }
  .next-sub {
    margin-top: 4px;
    font-size: 12px;
    color: #86909c;
    line-height: 18px;
  }
  .next-btn {
    width: 88px;
    height: 36px;
  }
}
</style>

